import { FUTURES_PERIOD_OPTIONS } from '../constants/futuresPeriod';

/** 格式化跟單週期標籤 */
export function formatFollowPeriodLabel(periodType) {
  if (!periodType) {
    return '—';
  }
  const matched = FUTURES_PERIOD_OPTIONS.find((item) => item.enumName === periodType);
  if (matched) {
    return matched.label;
  }
  return String(periodType).replace(/^_/, '');
}

/** 格式化跟單金額展示 */
export function formatFollowAmount(value, digits = 6) {
  const num = Number(value);
  if (Number.isNaN(num)) {
    return '—';
  }
  return num.toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

/** 餘額比例跟單金額（對齊後端 RoundingMode.DOWN、scale 10） */
export function computeRemainingPercentAmount(balance, percentValue) {
  const balanceNum = Number(balance);
  const percent = Number(percentValue);
  if (Number.isNaN(balanceNum) || Number.isNaN(percent) || percent <= 0) {
    return 0;
  }
  const raw = (balanceNum * percent) / 100;
  return Math.floor(raw * 1e10) / 1e10;
}

/** 解析手動金額區間 amountValue（min,max） */
export function parseManualAmountRange(amountValue) {
  if (!amountValue) {
    return { min: 0, max: 0 };
  }
  const parts = String(amountValue).split(',');
  return {
    min: Number(parts[0]),
    max: Number(parts[1]),
  };
}

export function isManualFollowAmount(amountType) {
  return amountType === 'MANUAL_AMOUNT';
}

export function isPercentFollowAmount(amountType) {
  return amountType === 'REMAINING_PERCENTAGE';
}

/** 依商品代碼篩選可跟單列表（空代碼則不篩選） */
export function filterFollowOrdersBySymbol(records, symbol) {
  const normalized = symbol ? String(symbol).trim().toUpperCase() : '';
  if (!normalized) {
    return records || [];
  }
  return (records || []).filter(
    (item) =>
      String(item.marketSymbolCode || '')
        .trim()
        .toUpperCase() === normalized
  );
}
